import { IJobCandidateInteraction } from 'wisestep-api';

export const MappingListDefaultRequest: IJobCandidateInteraction = {
  searchScope: 'EVERYTHING',
  currentStageStatus: '',
  radiusInMiles: 100,
  searchInCurrentLocation: true,
  searchInPreferredLocation: true,
  candidateSearchType: 'All',
  searchAcross: ['ACROSS_WORKSPACE'],
  page: 0,
  size: 50,
  sort: ['_score,desc'],
  currentStageCurrentStatusPairs: [],
  jobSearchFields: ['currentJobTitle', 'mappedJobTitle', 'previousJobTitles'],
  candidateSearchTypeList: [],
  datesUnionBy: 'UPDATED_BETWEEN',
  source: 'PIPELINE',
  queryType: 'none',
  searchWithMostRecentConversation: false,
  candidateResponses: [],
  recruiterActions: [],
};
